import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Login from "../../src/components/pages/login";
// import UploadProfile from "../../src/components/pages/uploadProfile";
// import CreateSms from "../components/pages/createSms";
import Dashboard from "../components/pages/dashboard";
import NoPage from "../../src/components/pages/noPage";
// import Campaign from "../components/pages/todaysCampaign";
// import ResetPass from "../components/pages/resetPass/resetPass";
// import VerifyOtp from "../components/pages/resetPass/verifyOtp";
// import NewPass from "../components/pages/resetPass/newPassword";
// import CreateMilestone from "../components/pages/createSms/milestone";
// import CreateTemplate from "../components/pages/createSms/createTemplate";
// import ExecutedCamp from "../components/pages/executedCamp";
// import ViewMore from "../components/pages/viewMore";
// import ComingSoon from "../components/pages/comingSoon";
// import LoginAuth from "../components/pages/loginAuth";
// import ViewMoreCdr from "../components/pages/viewMoreCdr";
// import TotalCDRs from "../components/pages/totalCDR";
import UrlAnalytics from "../components/pages/urlAnalytics";
import ProtectedRoute from "../Protected/ProtectedRoutes";
import HeaderRegist from "../components/pages/headerReg";
import ManageUrl from "../components/pages/campaignUrls/manageUrl";
import CreateCampaign from "../components/pages/campaignUrls/createCamp";
import ViewMoreCampaign from "../components/pages/campaignUrls/viewMoreCamp";


function MainRoutes() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/" exact element={<Login />} />
        <Route path="/loginAuth" element={<LoginAuth />} />

        <Route path="/resetPass" element={<ResetPass />} />
        <Route path="/verifyOtp" element={<VerifyOtp />} />
        <Route path="/newPassword" element={<NewPass />} /> */}

        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/headerRegistration" element={<ProtectedRoute><HeaderRegist /></ProtectedRoute>} />
        <Route path="/urlAnalytics" element={<ProtectedRoute><UrlAnalytics /></ProtectedRoute>} />
        <Route path="/manageUrl" element={<ProtectedRoute><ManageUrl /></ProtectedRoute>} />
        <Route path="/manageUrl/create" element={<ProtectedRoute><CreateCampaign /></ProtectedRoute>} />
        <Route path="/manageUrl/view" element={<ProtectedRoute><ViewMoreCampaign /></ProtectedRoute>} />

        {/* <Route path="/uploadProfile" element={<ProtectedRoute><UploadProfile /></ProtectedRoute>} /> */}
        {/* <Route path="/createSms" element={<ProtectedRoute><CreateSms /></ProtectedRoute>} />
        <Route path="/createSms/createTemplate" element={<ProtectedRoute><CreateTemplate /></ProtectedRoute>} />
        <Route path="/createSms/milestone" element={<ProtectedRoute><CreateMilestone /></ProtectedRoute>} /> */}
        {/* <Route path="/todaysCampaign" element={<ProtectedRoute><Campaign /></ProtectedRoute>} /> */}
        {/* <Route path="/todaysCampaign/viewMore" element={<ProtectedRoute><ViewMore /></ProtectedRoute>} /> */}
        {/* <Route path="/executedCamp" element={<ProtectedRoute><ExecutedCamp /></ProtectedRoute>} /> */}
        {/* <Route path="/executedCamp/viewMoreCdr" element={<ProtectedRoute><ViewMoreCdr /></ProtectedRoute>} /> */}
        {/* <Route path="/totalCDRs" element={<ProtectedRoute><TotalCDRs /></ProtectedRoute>} /> */}


        {/* <Route path="/comingSoon" element={<ProtectedRoute><ComingSoon /></ProtectedRoute>} /> */}
        <Route path="*" element={<NoPage />} />

      </Routes>
    </Router>
  );
}

export default MainRoutes;
